/**
 * Returns the byte length of an utf8 string
 */
export function utf8ByteLength(str) {
    let s = str.length;
    for (let i = str.length - 1; i >= 0; i--) {
        const code = str.charCodeAt(i);
        if (code > 0x7f && code <= 0x7ff) {
            s++;
        }
        else if (code > 0x7ff && code <= 0xffff) {
            s += 2;
        }
        if (code >= 0xdc00 && code <= 0xdfff) {
            i--;
        } //trail surrogate
    }
    return s;
}
/**
 * Serializes provided object as JSON and
 * returns the byte length of an utf8 string
 */
export function jsonBytes(obj) {
    const str = JSON.stringify(obj);
    return utf8ByteLength(str);
}
//# sourceMappingURL=string-bytes.js.map